import FunnelWidget from './FunnelWidget';

export { FunnelWidget };
export default FunnelWidget;
